import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { withLoader } from '../../Common/Utils/Hoc'
import { ReportsDatabase } from '../../Core/Services/IndexedDb'
import Dropdown from '../../Common/Components/Dropdown'
import { setStateFromEvent } from '../../Common/Utils/Events'
import { Divider } from '@mui/material'
import TextField from '../../Common/Components/TextField'
import { FormControl } from '../../Common/Components/Forms'
import { pipe } from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import Modal from '../../Common/Components/Modal'

const Db = new ReportsDatabase()

const LocalReportSelectionModal = ({ onClose, manager }) => {
  const { t } = useTranslation()
  const [reports, setReports] = React.useState([])
  const [reportId, setReportId] = React.useState(null)
  const [newReportName, setNewReportName] = React.useState('')
  const [itemName, setItemName] = React.useState('')
  const [serializedData, setSerializedData] = React.useState({})
  const [isLoading, setIsLoading] = React.useState(true)

  React.useEffect(async() => {
    const data = await manager.serializeItem()
    setItemName(data.name)
    setSerializedData(data)
  }, [])

  React.useEffect(() => {
    const getReports = async () => {
      await Db.open()
      const reports = await Db.getAll()
      setReports(reports)
      setIsLoading(false)
    }

    getReports()
  }, [])

  const handleSubmit = () => {
    const item = {
      ...serializedData,
      name: itemName,
      id: uuidv4(),
    }
    if (newReportName) {
      Db.addReport({
        name: newReportName,
        items: [item],
      })
    } else {
      Db.addReportItem(reportId, item)
    }

    onClose()
  }

  return (
    <Modal
      onClose={onClose}
      maxWidth="sm"
      title={t('common:ui.AddToLocalReport')}
      onSubmit={handleSubmit}
      submitDisabled={!reportId && !newReportName}
    >
      {withLoader(() => {
        return (
          <div>
            <FormControl>
              <TextField
                label={t('common:ui.ItemName')}
                value={itemName}
                onChange={setStateFromEvent(setItemName)}
                width="100%"
              />
            </FormControl>
            <FormControl>
              <Dropdown
                label={t('common:ui.SelectExistingReport')}
                value={reportId}
                onChange={setStateFromEvent(setReportId)}
                options={reports.map((r) => ({ value: r.id, label: r.name }))}
              />
            </FormControl>
            <Divider style={{ margin: '2rem 0' }}>{t('common:ui.OR')}</Divider>
            <FormControl>
              <TextField
                label={t('common:ui.CreateReport')}
                value={newReportName}
                onChange={pipe(setStateFromEvent(setNewReportName), () =>
                  setReportId(null),
                )}
                width="100%"
              />
            </FormControl>
          </div>
        )
      }, isLoading)}
    </Modal>
  )
}

LocalReportSelectionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  manager: PropTypes.object.isRequired,
}

export default LocalReportSelectionModal
